import * as DevClient from 'expo-dev-client';
import { Platform } from 'react-native';
import { UnistylesRuntime } from 'react-native-unistyles';

import { applyPlatformColorScheme } from '@/utils/platformColorScheme';

import i18n from './i18n';
import { createIndexedDBPersistor, storage, storageKeys } from './storage';

export const devMenuItems = [
  {
    name: 'Clear Storage',
    callback: () => {
      storage.clearAll();

      if (Platform.OS === 'web') {
        createIndexedDBPersistor().removeClient();
      }
    },
  },
  {
    name: 'Toggle theme',
    shouldCollapse: true,
    callback: () => {
      const nextTheme =
        UnistylesRuntime.themeName === 'dark' ? 'light' : 'dark';

      UnistylesRuntime.setTheme(nextTheme);
      // Flips native chrome too, so the app never ends up half dark.
      applyPlatformColorScheme(nextTheme);
      storage.set(storageKeys.devMenuTheme, nextTheme);
    },
  },
  {
    name: 'Cycle language',
    callback: () => {
      // Kept in step with the in-app DevMenu picker, which offers all three
      // locales the app ships translations for.
      const languages = ['en', 'es', 'fr'];
      const [current] = i18n.language.split('-');
      const nextIndex = (languages.indexOf(current) + 1) % languages.length;

      i18n.changeLanguage(languages[nextIndex]);
    },
  },
];

if (Platform.OS !== 'web') {
  DevClient.registerDevMenuItems(devMenuItems);
}
